import React from 'react'

import {createSvgIcon} from './utils'

export default createSvgIcon(
  <>
    <g clipPath="url(#clip0_574_19616)">
      <path
        d="M13 13C12.4477 13 12 13.4477 12 14V21C12 21.5523 12.4477 22 13 22H20C20.5523 22 21 21.5523 21 21V14C21 13.4477 20.5523 13 20 13L13 13Z"
        fill="#21201F"
        opacity="0.4"
      />
      <path
        clipRule="evenodd"
        d="M10.6341 8.26208C12.0872 8.26208 13.2651 7.08412 13.2651 5.63104C13.2651 4.17796 12.0872 3 10.6341 3C9.18101 3 8.00305 4.17796 8.00305 5.63104C8.00305 7.08412 9.18101 8.26208 10.6341 8.26208ZM12.0874 13.5892L12.7031 15.8504L15.9955 17.234C16.9628 17.6405 17.4415 18.7339 17.084 19.7203L11.9977 18.1535V18.1551L11.2796 17.9339C10.9229 17.8241 10.6529 17.5686 10.5128 17.254C10.4346 17.1493 10.3712 17.031 10.3266 16.9011L10.1979 16.5257L8.90344 22H2.97228L4.15307 19.7153L6.06337 11.6366C6.39244 10.245 7.78735 9.38358 9.17899 9.71265L10.4098 10.0037C10.9111 10.1222 11.2747 10.5173 11.3774 10.9892C11.3837 11.0085 11.3897 11.0281 11.3953 11.0478C11.3966 11.0526 11.398 11.0574 11.3993 11.0621M3.31188 27H2.4707C2.74969 27.0794 3.04101 27.0766 3.31188 27Z"
        fill="#21201F"
        fillRule="evenodd"
      />
      <path
        d="M22 22.3008L2 22.3008C2 21.7485 2.44772 21.3008 3 21.3008L21 21.3008C21.5523 21.3008 22 21.7485 22 22.3008Z"
        fill="#21201F"
      />
    </g>
    <defs>
      <clipPath id="clip0_574_19616">
        <rect fill="white" height="24" width="24" />
      </clipPath>
    </defs>
  </>,
  'PickupPointsIcon',
)
